import React, {
  useCallback,
  useContext,
  useEffect,
  Suspense,
  useState,
  useMemo,
  useRef
} from "react";
import styles from "./index.module.less";
import { Switch, useHistory, Redirect, Route } from "react-router-dom";
import CacheRoute, { CacheSwitch, clearCache } from "react-router-cache-route";
import routerConfig, { thirdAppPath, homeAppPath, linkContainerPath, joyspacePath } from "@/router/v2";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import LoginPage from "@/pagesv2/LoginPage";
import { connect } from "dvajs";
import UserCardModal from "@/components/Modals/UserCardModal";
import OrgAcctModal from "@/components/Modals/OrgAcctModal";
import SearchGlobalModal from "@/components/Modals/SearchGlobalModal";
import CreateSchedule from "@/components/Calendars/Create";
import FullIframeModal from "@/components/Work/BaseComponents/FullIframeModal";
import SuperviseDetail from "@/components/Supervise/components/SuperviseDetail";
import SuperviseCreate from "@/components/Supervise/components/SuperviseCreate";
import ScheduleDraw from "@/components/Projects/components/CalendarView/ScheduleDraw";
import ScheduleDrawOther from "@/components/Projects/components/CalendarView/ScheduleDrawOther";
import TaskDetailDraw from "@/components/Work/TaskDetailDraw";
import BaseMeetingCallModal from "@/baseComponents/Meeting/MeetingCallModal";
import EventBus from "@/utils/bus";
import { useTranslation } from "react-i18next";
import ZoomLogin from "@/components/Meeting/zoomLogin";
import MeetingControl from "@/baseComponents/Meeting/index";
import UploadBox from "@/components/Joyspace/components/UploadBox";
import GlobalLayout from "@/layout/GlobalLayout";
import ExitTipModal from "@/components/Modals/ExitTipModal";
import DeeplinkHandler from "@/components/DeeplinkHandler";
import VoipLogin from "@/components/Voip/VoipLogin";
import JoyspaceFileSelectorModal from "@/components/Modals/JoyspaceFileSelectorModal";
import WorkStatusModal from "@/components/Modals/WorkStatusModal";
import { FocusSDK, isFocusEnv } from "@/utils";
import TaskDetailEditDraw from "@/components/Work/TaskDetailEditDraw";
import ApplyExternalContactsList from "@/components/Modals/ApplyExternalContactsList";
import ExternalApplyListNoticeList from "@/components/Modals/ManageExternal/ExternalApplyList";
import ContactModal from "@/components/Modals/AddContactModal";
import AddRobotModal from "@/components/Modals/AddRobotModal";
import IdentityInfoModal from "@/components/Modals/IdentityInfoModal";
// import NewVersionGuideModal from '@/components/Modals/NewVersionGuideModal';
// 用户指引
import UserGuideModal from "@/components/Modals/UserGuideModal";
import JDMeetWebReceiveModal from "@/components/MeetingJD/JDMeetWebReceiveModal";
import GroupSlitaire from "@/components/Work/Solitaire";
import CreateTaskDraw from "@/components/Work/CreateTaskDraw";
// import LabelModal from '@/components/AddressBook/right/labels';
import GroupNotificationBox from "@/components/chat/message/GroupNotification";
import NoticeDetailsCard from "@/components/chat/message/GroupNotificationCard/NoticeDetailsCard";
import MigrateModal from "@/components/Modals/MigrateModal";
import { message } from "antd";
import PrivateNetExcepModal from "@/components/Modals/PrivateNetExcepModal";
import Context from "@/components/chat/context";
import RefusalCause from "@/components/Modals/ApplyExternalContactsList/RefusalCause";
import SolitaireDetails from "@/components/chat/message/SolitaireCard/SolitaireDetails";
import SlitaireHis from "@/components/Work/Solitaire/solitaireHistory";
import GlobalFTPCollapsePanel from "@/components/GlobalFTPCollapsePanel";
import History from "@/components/chat/message/GroupNotification/components/history";
import GroupSpaceDrawer from "@/components/chat/message/GroupSpaceDrawer";
import ManageExternal from "@/components/Modals/ManageExternal";
import ManageNoticeList from "@/components/Modals/ManageExternal/ManageNoticeList";
import { batchSendMessage } from "@/components/BrowserView/msgCardHelper";
import { crossAppSwitch } from "@/utils/tools";
import { getAuthorizationCode } from "@/api/user";
import { judgeFreeUse } from "@/api/appStore";
import { AppTrialStatus, getTrialStatus } from "@/components/ThirdApp/utils";
import { handleNewWindow, handleWindowData } from "@/pagesv2/NewWindow/util";
import ImCollapsePanel from "@/baseComponents/Chat/ImCollapsePanel";
import getAppEntry from "@/utils/entry";
import { handleCreateSingleMeeting } from "@/baseComponents/Meeting/utils";
import { handleCreateGroupMeeting } from "@/components/UserCard/common";
import ImService from "@/server/ImService";
import BusyIdleViewDraw from "@/components/Calendars/Create/BusyIdleViewDraw";
import { joinLive } from "@/baseComponents/Meeting/utils";
import { AVSDK } from "@/baseComponents/Meeting/common";
import { UserCardType } from "@/types/UserCard";
import ReminderWindow from "../NewWindow/ReminderWindow";
import useGroupUserSelector from "@/components/chat/GroupUserSelector";
import { AI_CHAT_PREDICT, Employee } from "@/types/chat";
import { createJoySpaceLink } from "@/utils/chat/message";
import { getAIChatSessionId, getAIChatWinSessionId } from "@/utils/chat/session";
import { PermissionEnum } from "@/components/Joyspace/const";
import { isSupprotAbstract } from "@/components/Joyspace/util";
import { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import JoinTeamModal from "@/components/JoinTeamModal";
import { userDataStore } from "@/utils/user";
import ApplyTeamContactsList from "@/components/Modals/ApplyTeamContactsList";

// web端postMessage判断是否为京办首页
(window as any).isJZBHomePage = true;
interface IProps {
  setCreateModalInputValue: Function;
  openCreateContactModal: Function;
  setAddRobotModalInputValue: Function;
  openAddRobotModal: Function;
  setCurrentAIRobot: Function;
  currentEmployee: Employee;
  getLLMTagsList: Function;
}
function HomePage({
  userData,
  setCreateModalInputValue,
  openCreateContactModal,
  setAddRobotModalInputValue,
  openAddRobotModal,
  currentEmployee,
  setCurrentAIRobot,
  getLLMTagsList,
  themes
}: { userData: any; themes: string } & IProps) {
  const { focusSDK, service, appRuntimeEnv, onReLogin, authInfo } = useContext<GlobalContextConfig>(
    GlobalContext
  );
  const history = useHistory();
  const { t } = useTranslation("common");
  const [dnsVisible, setDnsVisible] = useState(false);
  const canShortcut = useRef(true);
  const pathname = history.location.pathname;
  useEffect(() => {
    console.log("authInfo,test", authInfo);
  }, [authInfo]);
  const onAutoLogin = useCallback(() => {
    console.log("relogin3");
    service.authService
      .relogin()
      .then((res: any) => {
        FocusSDK.printLog("webapp:onAutoLogin", JSON.stringify(res), authInfo);
        const d = {
          ...authInfo,
          ...res
        };
        focusSDK.login(
          d,
          appRuntimeEnv.selectedTeamId,
          () => {
            onReLogin(d);
          },
          appRuntimeEnv.registryConfig.autoLoginChecked
        );
      })
      .catch((e) => {
        // userDataStore.isLogin = false;
        FocusSDK.printLog("HomePage-autoLogin-e", `${JSON.stringify(e)}-${e}-${e.message}`);
        if (e.message.includes("Failed to fetch")) {
          FocusSDK.printLog("HomePage-autoLogin-e", "Failed to fetch");
          EventBus.emit("chat:state-auth-faild");
        }
        if (e.message.includes("failed to refresh token")) {
          focusSDK.logout("expired");
          // 退出断开连接
          ImService.getInstance()?.closeWS();
        }
      });
  }, [
    appRuntimeEnv.selectedTeamId,
    authInfo,
    focusSDK,
    onReLogin,
    service.authService,
    appRuntimeEnv.registryConfig.autoLoginChecked
  ]);
  const onLogout = useCallback(() => {
    clearCache();
  }, []);
  useEffect(() => {
    focusSDK.off("logout", onLogout).on("logout", onLogout);
    return () => {
      focusSDK.off("logout", onLogout);
    };
  }, [onLogout]);
  // 这里处理的是mac离线消息跳转
  const onLocationChange = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history]
  );

  const newMsgCb = useCallback(
    ({ message }: any) => {
      if (isFocusEnv()) {
        focusSDK.sendIpcMessage("messageNotify", message);
      }
    },
    [focusSDK]
  );

  const handleOpenThirdApp = useCallback((appInfo: any) => {
    history.push({
      pathname: "/third_apps"
      // state: { applicationInfo: data.ext },
    });
    setTimeout(() => {
      EventBus.emit("openThirdApp", appInfo);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenUserCard = useCallback((data: any) => {
    console.log("openUserCard:", data);
    FocusSDK.openUserCard({
      ...data,
      appId: data.app,
      type: UserCardType.CustomUser
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doHandleCreateSingleMeeting = useCallback((res: any) => {
    handleCreateSingleMeeting(res).catch((e) => message.error(e?.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const doHandleCreateGroupMeeting = useCallback((res: any) => {
    const { to, from, netState } = res;
    handleCreateGroupMeeting(to, from, netState).catch((e) => message.error(e?.message));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 添加联系人
  const handleSearchUser = useCallback(
    (res: any) => {
      const { keyword = "" } = res;
      openCreateContactModal({
        visible: true
      });
      setCreateModalInputValue(keyword);
    },
    [openCreateContactModal, setCreateModalInputValue]
  );

  // 创建群组
  const handleCreateGroup = useGroupUserSelector({
    currentEmployee,
    userData: userData ? userData.user : null
  });
  const controlMethod = (item: any) => {
    return item.status
      ? !item.permissions.includes(PermissionEnum.SHARE_CREATE) || !isSupprotAbstract(item)
      : true;
  };
  // 发送云文档
  const handleSendJoyspace = useCallback(
    async ({ sessionId }) => {
      const aiSid = await getAIChatSessionId();
      const sid = await getAIChatWinSessionId();
      const { joyspaceHost } = appRuntimeEnv;
      const callback = ({ status, results }: any) => {
        if (status === "cancel") {
          return;
        }
        const list = results.map((item: any) => {
          return {
            content: "",
            icon: item.icon,
            fileName: item.title,
            type: item.type,
            pageType: item.pageType,
            fileId: item.id,
            permissionType: item.permissionType,
            url: createJoySpaceLink(item, joyspaceHost)
          };
        });

        FocusSDK.sendMainMessage("aichat.chatEvent", {
          sessionId: sid,
          type: "selectJoyspace",
          list
        });
      };
      FocusSDK.emit("openJoyspaceDocSelector", {
        callbackId: sessionId,
        callback,
        max: 5,
        controlMethod,
        canSelectPermission: false
      });
    },
    [appRuntimeEnv]
  );

  // 切换智能体
  const handleAiAgentChange = useCallback(
    (data: any) => {
      console.log(`tj:>>>>>handleAiAgentChange>>`, data);
      setCurrentAIRobot(data);
      getLLMTagsList({
        agentId: data?.agentId,
        force: true
      });
    },
    [setCurrentAIRobot]
  );

  // 打开日程
  const handleOpenCalendar = useCallback((res) => {
    focusSDK?.emit("handleDeeplinkParams", {
      data: res,
      pathname: DeeplinkPathEnum.Schedule_Draw
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    focusSDK.on("autoLogin", onAutoLogin);
    return () => {
      focusSDK.off("autoLogin", onAutoLogin);
    };
  }, [onAutoLogin]);
  useEffect(() => {
    console.log("***homePage组件被调用***");
    if (!history) {
      return;
    }
    focusSDK.on("locationChange", onLocationChange);

    let dispose: { (): void; (): void } | null = null;
    if (isFocusEnv()) {
      dispose = focusSDK.addIpcEventListener("locationChange", onLocationChange);
      FocusSDK.on("window.openNewWindow", handleNewWindow);
      FocusSDK.on("window.sendWindowData", handleWindowData);
      FocusSDK.on("ai:mt:single:meeting:create", doHandleCreateSingleMeeting);
      FocusSDK.on("ai:mt:group:meeting:create", doHandleCreateGroupMeeting);
      FocusSDK.on("ai:thridapp:open", handleOpenThirdApp);
      FocusSDK.on("ai:openUserCard", handleOpenUserCard);
      FocusSDK.on("ai:global:add_friend", handleSearchUser);
      FocusSDK.on("ai:global:create_group", handleCreateGroup);
      FocusSDK.on("ai:global:send_joyspace", handleSendJoyspace);
      FocusSDK.on("ai:global:openSchedule", handleOpenCalendar);
      FocusSDK.on("ai:global:aiAgentChange", handleAiAgentChange);
    }
    EventBus.on("chat_message_new_message", newMsgCb);

    // if (focusSDK.isPrivateNet()) {
    //     // 初始dns设置存在问题且重设后依旧存在问题
    //     if (!focusSDK.privateDnsIsTrue() && !focusSDK.newPrivateDnsIsTrue) {
    //         setDnsVisible(true);
    //     }
    // }

    return () => {
      focusSDK.off("locationChange", onLocationChange);
      dispose?.();
      EventBus.off("chat_message_new_message", newMsgCb);
      if (isFocusEnv()) {
        FocusSDK.off("window.openNewWindow", handleNewWindow);
        FocusSDK.off("window.sendWindowData", handleWindowData);
        FocusSDK.off("ai:mt:single:meeting:create", doHandleCreateSingleMeeting);
        FocusSDK.off("ai:mt:group:meeting:create", doHandleCreateGroupMeeting);
        FocusSDK.off("ai:thridapp:open", handleOpenThirdApp);
        FocusSDK.off("ai:openUserCard", handleOpenUserCard);
        FocusSDK.off("ai:global:add_friend", handleSearchUser);
        FocusSDK.off("ai:global:create_group", handleCreateGroup);
        FocusSDK.off("ai:global:send_joyspace", handleSendJoyspace);
        FocusSDK.off("ai:global:openSchedule", handleOpenCalendar);
        FocusSDK.off("ai:global:aiAgentChange", handleAiAgentChange);
      }
    };
  }, []); // eslint-disable-line

  // 是否注册1v1阅后即焚快捷键
  useEffect(() => {
    if (isFocusEnv()) {
      if (pathname.indexOf(":secret") > -1) {
        canShortcut.current = false;
        FocusSDK.captureScreenShortcut(true);
      } else if (!canShortcut.current) {
        canShortcut.current = true;
        FocusSDK.captureScreenShortcut(false);
      }
    }
  }, [pathname]);

  const postMessageHandler = (e: any) => {
    let { type, cid, options: data } = e?.data || {};
    console.log("收到三方应用传递消息", data, type, cid);
    if (type === "batchSendMessage") {
      batchSendMessage({
        data,
        cid,
        service,
        sendToMessage: (arg: any) => {
          e?.source?.postMessage(
            {
              type: "batchSendResult",
              ...arg
            },
            "*"
          );
        }
      });
      // web端jssdk获取focus-open-code
    } else if (type === "getAuthorizationCode") {
      getAuthorizationCode(data)
        .then((res) => {
          let result;
          const [success, err] = res;
          if (success) {
            result = {
              statusCode: 0,
              ...success
            };
          } else {
            result = {
              statusCode: 1,
              err
            };
          }
          e?.source?.postMessage(
            {
              type: "getAuthorizationCode",
              cid,
              data: result
            },
            "*"
          );
        })
        .catch((err) => {
          console.log(err);
        });
      // web端获取appRuntimeEnv
    } else if (type === "getAppRuntimeEnv") {
      e?.source?.postMessage({ type: "getAppRuntimeEnv", cid, data: appRuntimeEnv }, "*");
    } else if (type === "getAuthInfo") {
      e?.source?.postMessage({ type: "getAuthInfo", cid, data: authInfo }, "*");
    } else if (type === "appTrialDialog") {
      judgeFreeUse({ applicationId: data.applicationId })
        .then((res: any) => {
          const appTrialStatus = getTrialStatus({
            applyInfo: res,
            isInsideApp: data.isInsideApp
          });
          e?.source?.postMessage(
            {
              type: "appTrialDialog",
              cid,
              data: {
                appTrialStatus,
                applyPageUrl: `${getAppEntry()}/app-apply.html`,
                trialDays: res.trialDays
              }
            },
            "*"
          );
        })
        .catch((e) => {
          e?.source?.postMessage(
            {
              type: "appTrialDialog",
              cid,
              data: {
                appTrialStatus: AppTrialStatus.NORMAL
              }
            },
            "*"
          );
        });
    } else if (type === "joinLive") {
      let { type: liveType, ...restLiveInfo } = data;
      liveType = liveType || "jrtcLive";
      joinLive(liveType, restLiveInfo, history).then(
        () => {
          e?.source?.postMessage(
            {
              type: "joinLiveResult",
              cid,
              data: {
                statusCode: 0,
                message: "成功"
              }
            },
            "*"
          );
        },
        (err) => {
          e?.source?.postMessage(
            {
              type: "joinLiveResult",
              cid,
              data: {
                statusCode: -1,
                message: err?.message || "异常调用"
              }
            },
            "*"
          );
        }
      );
    } else if (type === "openThirdapp") {
      EventBus.emit("openThirdApp", data.application);
    }
  };

  // webview传递消息到宿主应用
  useEffect(() => {
    window.addEventListener("message", postMessageHandler);
    return () => {
      window.removeEventListener("message", postMessageHandler);
    };
  }, [appRuntimeEnv, authInfo, service]);

  return (
    <div className={`${styles["container"]} themes ${themes}`}>
      {authInfo && (
        <>
          <ApplyExternalContactsList />
          <ExternalApplyListNoticeList />
          <ApplyTeamContactsList />
          <ManageExternal />
          <ManageNoticeList />
          <RefusalCause />
          <IdentityInfoModal />
          <ContactModal />
          <AddRobotModal />
          {/* <LabelModal /> */}
          <SearchGlobalModal />
          <MeetingControl />
          <BaseMeetingCallModal />
          <CreateSchedule />
          <BusyIdleViewDraw />
          <FullIframeModal />
          <ScheduleDraw />
          <ScheduleDrawOther />
          <SuperviseDetail />
          <NoticeDetailsCard />
          <SuperviseCreate />
          <CreateTaskDraw />
          <TaskDetailDraw />
          <TaskDetailEditDraw />
          <ZoomLogin />
          <UserCardModal />
          <OrgAcctModal />
          {/* <UploadBox /> */}
          <GlobalFTPCollapsePanel />
          <JoyspaceFileSelectorModal />

          <DeeplinkHandler history={history} />
          <VoipLogin />
          <WorkStatusModal />
          {/* <NewVersionGuideModal /> */}
          {/* {!crossAppSwitch("meeting") && <UserGuideModal />} */}
          <JDMeetWebReceiveModal />
          <GroupNotificationBox />
          <GroupSlitaire />
          <SolitaireDetails />
          <History />
          <SlitaireHis />
          <GroupSpaceDrawer />
          {pathname.indexOf("messages") > -1 && <ImCollapsePanel gid="im" />}
          <ReminderWindow />
          {isFocusEnv() ? <MigrateModal /> : null}
          <JoinTeamModal />
        </>
      )}
      <ExitTipModal />
      <GlobalLayout>
        <Switch>
          <Route key="/login" path="/login" exact render={() => <LoginPage />} />
        </Switch>
        <Switch>
          {routerConfig.map((item) => {
            const Component = item.component;
            return (
              item.path !== thirdAppPath &&
              item.path !== homeAppPath &&
              item.path !== linkContainerPath &&
              item.path !== joyspacePath && (
                <Route
                  key={item.path}
                  exact={typeof item.exact === "undefined" || item.exact}
                  path={item.path}
                  render={(props) => {
                    return (
                      <Suspense fallback={() => <div>loading...</div>}>
                        <Component />
                      </Suspense>
                    );
                  }}
                />
              )
            );
          })}
        </Switch>

        <CacheSwitch>
          {routerConfig.map((item) => {
            const Component = item.component;
            return (
              (item.path === thirdAppPath ||
                item.path === homeAppPath ||
                item.path === linkContainerPath ||
                item.path === joyspacePath) && (
                <CacheRoute
                  cacheKey={item.path === thirdAppPath ? authInfo?.userId + item.path : item.path}
                  key={item.path === thirdAppPath ? authInfo?.userId + item.path : item.path}
                  exact={typeof item.exact === "undefined" || item.exact}
                  path={item.path}
                  render={(props) => {
                    return <Component />;
                  }}
                />
              )
            );
          })}

          {/* <Route exact path="/chat/:type(s|g|n)/:id" component={ChatSupportPage} /> */}
        </CacheSwitch>
        <Switch>
          <Redirect to="/" />
        </Switch>
      </GlobalLayout>
      {/* <PrivateNetExcepModal dnsVisible={dnsVisible} /> */}
    </div>
  );
}

function mapStateToProps({ user, chat }: any) {
  return {
    themes: user.themes,
    userData: user.userData,
    currentEmployee: chat.currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    clearChatData: () => {
      dispatch({ type: "chat/clearData" });
    },
    openCreateContactModal(data: any) {
      dispatch({ type: "ebook/openCreateContactModal", payload: data });
    },
    setCreateModalInputValue(data: any) {
      dispatch({ type: "ebook/setCreateModalInputValue", payload: data });
    },
    setCurrentAIRobot(data: any) {
      dispatch({ type: "chat/setCurrentAIRobot", payload: data });
    },
    getLLMTagsList(payload: any) {
      dispatch({ type: "chat/getLLMTagsList", payload });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
